import { OptionsObject } from 'notistack';
import { createTheme } from '@mui/material/styles';
import { ThemeOptions } from '@mui/material/styles';
import { ButtonProps, CircularProgress, GridProps, responsiveFontSizes } from '@mui/material';

export const defaultSnackbarErrorProps: OptionsObject = {
  variant: 'error',
  persist: true,
};

export const defaultGridItemProps: GridProps = { item: true, xs: 12 };
export const defaultGridContainerProps: GridProps = { container: true, spacing: 4 };

export const materialIconsClassName = 'material-icons-outlined';

export const getButtonLoadingProps = (loading?: boolean): ButtonProps => ({
  startIcon: loading && <CircularProgress color={'inherit'} size={16} />,
});

export const appTheme: Partial<ThemeOptions> = {
  palette: {
    primary: {
      main: '#55a51c',
      contrastText: '#ffffff',
    },

    secondary: {
      main: '#005abb',
      contrastText: '#ffffff',
    },
    text: {
      primary: '#333333',
    },
  },
  typography: {
    fontSize: 16,
    fontFamily: ['Gotham A', 'Gotham B', 'sans-serif'].join(','),
    body1: {
      fontSize: 16,
    },
    button: {
      textTransform: 'none',
    },
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 768,
      md: 960,
      lg: 1100,
      xl: 1920,
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          transition: 'color .01s',
          borderRadius: '25px', // Match .superRadius
        },
      },
    },
  },
};

export const semiTheme = responsiveFontSizes(createTheme(appTheme));
